let obj = {};
obj.companyIdTypeOptions = [
    {
        value: "04",
        name: "统一社会信用代码",
    },
    {
        value: "01",
        name: "组织机构代码证",
    },
    {
        value: "02",
        name: "营业执照"
    },
    {
        value: "03",
        name: "税务登记证"
    },
    {
        value: "99",
        name: "其他",
    }
]
//计划
obj.plansValues = [
    {
        name: '计划一',
        value: 'STARR_ZHUANGXIUBAO1',
        money1: '10万（含）-60万（含）',
        money2: '50万',
        money3: '3万',
        premium: '1000',
        min: 100000,
        max: 600000
    },{
        name: '计划二',
        value: 'STARR_ZHUANGXIUBAO2',
        money1: '10万（含）-60万（含）',
        money2: '50万',
        money3: '5万',
        premium: '1250',
        min: 100000,
        max: 600000
    },{
        name: '计划三',
        value: 'STARR_ZHUANGXIUBAO3',
        money1: '10万（不含）-40万（含）',
        money2: '100万',
        money3: '6万',
        premium: '2000',
        min: 100001,
        max: 400000
    },{
        name: '计划四',
        value: 'STARR_ZHUANGXIUBAO4',
        money1: '40万（不含）-70万（含）',
        money2: '100万',
        money3: '6万',
        premium: '2550',
        min: 400001,
        max: 700000
    },{
        name: '计划五',
        value: 'STARR_ZHUANGXIUBAO5',
        money1: '70万（不含）-100万（含）',
        money2: '100万',
        money3: '6万',
        premium: '2800',
        min: 700001,
        max: 1000000
    },{
        name: '计划六',
        value: 'STARR_ZHUANGXIUBAO6',
        money1: '100万（不含）-300万（含）',
        money2: '100万',
        money3: '6万',
        premium: '4200',
        min: 1000001,
        max: 3000000
    },{
        name: '计划七',
        value: 'STARR_ZHUANGXIUBAO7',
        money1: '100万（不含）-300万（含）',
        money2: '100万',
        money3: '10万',
        premium: '4800',
        min: 1000001,
        max: 3000000
    }
]
//客户性质
obj.customerQuality = [
    { name: '法人', value: '01' }
]
//施工资质
obj.constructionNature = [
    { name: '特级', value: '3' },
    { name: '一级', value: '1' },
    { name: '二级', value: '2' },
    { name: '三级', value: '4' },
] 
//施工类型
obj.constructionType = [
    { name: '室内装修工程（无室外）', value: '1' }
] 
//关联投保人column
obj.columns = [
    { title:'序列号',dataIndex:'idx',key:'idx',align:'center',scopedSlots:{customRender:'idx'}},
    { title: '企业名称', dataIndex: 'companyName', key: 'companyName', align: 'center',
        scopedSlots:{customRender:'companyName'}},
    { title:'操作',dataIndex:'operation',key:'operation',align:'center',
        scopedSlots:{customRender:'operation'}
    }
]

export default { ...obj }